import React, { useRef } from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { Arrow, FieldChecked } from '@/icons/index';
import { allValues } from '@/constants/base';
import useOnClickOutside from '@/hooks/useClickOutside';

import styles from './Select.module.scss';

export default function Select({
  label = '',
  placeholder = '',
  onChange,
  value,
  onBlur = () => null,
  data = [],
  className,
  withoutIcon,
  disabled,
  ...props
}) {
  const { t } = useTranslation();
  const [isListShown, setIsListShown] = React.useState(false);
  const listRef = useRef(null);
  const selectRef = useRef(null);

  const changeValue = (currentValue) => {
    onChange(currentValue);
    setIsListShown(false);
  };

  const outsideClickHandler = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsListShown(false);
    }
  };

  useOnClickOutside(listRef, outsideClickHandler);

  const renderOptions = (item, key) => {
    const val = value?.id ? 'id' : 'name';
    const valInsideOfValue = value?.[val];
    const valInsideOfItem = item?.[val];

    return (
      <li
        key={key}
        onMouseDown={() => changeValue(item)}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {t(item?.name)}
        {valInsideOfValue === valInsideOfItem && !withoutIcon && (
          <FieldChecked />
        )}
      </li>
    );
  };

  const handleBlur = (event) => {
    setIsListShown(false);
    return onBlur(event);
  };
  return (
    <div
      className={classNames([
        styles.searchSelect,
        {
          [styles.selectActive]: isListShown,
          [styles.haveValue]: !!value?.name,
          [styles.disabled]: disabled,
        },
      ])}
      onBlur={handleBlur}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div
        onClick={() => setIsListShown(!isListShown)}
        className={styles.searchSelectField}
        ref={selectRef}
      >
        {label && <span className={`label ${styles.inputLabel}`}>{label}</span>}
        <input
          placeholder={placeholder}
          autoComplete='off'
          type='text'
          value={
            allValues.includes(value?.value) || value?.name === 'All'
              ? t('common:All')
              : t(value?.name)
          }
          className={classNames(['input', styles.input, className])}
          onChange={() => null}
          readOnly
          aria-label={value?.name}
          {...props}
        />
        <Arrow width={14} />
      </div>
      <ul ref={listRef} className={styles.selectList}>
        {!!data.length && data.map(renderOptions)}
      </ul>
    </div>
  );
}
